import { Injectable, Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import{environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  baseUrl = environment.baseUrllogging;
 
   source = "rentconnect-app";
 
   constructor(private httpClient: HttpClient,  private loggerService:LoggerService) { }
 
   public getLogUrl (){
     return this.baseUrl ;
   }
 
 
   private getUserInfo (){
     return {
       DomainAccountId: 'abc',
       UserId: 'xxxx'
     }
   }
 
   private getBrowser(){
     return navigator.appName;
   }
 
   private getUrl (){
     return window.location.href;
   }
 
    private saveLog (errmodule, procedures, msg, type){

     var user = this.getUserInfo ();
     var log = Object.assign ({
       BrowserAgent : this.getBrowser (), 
       UserId : user.UserId, 
       DomainAccountId: user.DomainAccountId,
       Url : this.getUrl(),
      //  Module: errmodule,
       Module: errmodule || "UNKNOWN",

       procedures: procedures,
       Message: msg, 
       MessageTypeCode: type,
       Address: "100.22.222678",
       
     }, environment.logger); 
      this.httpClient.post (this.getLogUrl(), log)
      .subscribe (res => {
       //done.
      });
   }
 
 
   saveErr (errmodule, procedures, msg){
   //  log.type = "error";
     this.saveLog (errmodule, procedures, msg, "Error");
   }
 
   saveInfo (errmodule, procedures, msg){
    // log.type = "information";
    this.saveLog (errmodule, procedures, msg, "Information");
   }
 
   saveWarn (errmodule, procedures, msg){
     // log.type = "Warning";
     this.saveLog (errmodule, procedures, msg, "Warning");
    }
    saveDebug (errmodule, procedures, msg){
     // log.type = "Debug";
     this.saveLog (errmodule, procedures, msg, "Debug");
    }
  
 }